/* eslint-disable */
import React from 'react';
// import { Carousel } from 'react-bootstrap';
import { Link } from 'react-router-dom';

function BookKeepBanner() {
    
    return (
        <>

            
        <div className="banner">
            <img
                src='/assets/images/bookkeep.jpg'
                alt="ConnectMyVA Bookkeeping and Accounting Services"
                    title="Expert Bookkeeping Support for Small Businesses - ConnectMyVA"
                className="bannerImage"
            />
        </div>
            

        </>
    )
}

export default BookKeepBanner
